export const actionTypes = {
  SET_NEWLY_CREATED_TEAM: 'SET_NEWLY_CREATED_TEAM',
  SET_BASE_LIST: 'SET_BASE_LIST',
  SET_VIEW_LIST: 'SET_VIEW_LIST',
  SET_DELETE_VOICE_MODAL: 'SET_DELETE_VOICE_MODAL',
  SET_DELETE_VOICE_MODAL_INFO: 'SET_DELETE_VOICE_MODAL_INFO',
  SET_EDIT_TEAM_INFO: 'SET_EDIT_TEAM_INFO',
  SET_SEARCH_TERM: 'SET_SEARCH_TERM',
  DELETE_TEAM_VOICE: 'DELETE_TEAM_VOICE',
  FILTER_VIEW_LIST: 'FILTER_VIEW_LIST',
  SET_SORT: 'SET_SORT',
  UPDATE_TEAM: 'UPDATE_TEAM',
  ADD_TEAM_TO_LIST: 'ADD_TEAM_TO_LIST',
  SET_BACKDROP: 'SET_BACKDROP',
  SET_TEAMS_LIST_IS_LOADING: 'SET_TEAMS_LIST_IS_LOADING',
  SET_USERS_FEATURES: 'SET_USERS_FEATURES',
};
